var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.64 24.035H24.716v12.076h17.922V24.036z",
    fill: "#FFD6C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.49 15.467L25.4 24h16.933l-8.843-8.533z",
    fill: "#EC368D",
    stroke: "#EC368D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.033 15.944v1.46l-3.266 3.094v-4.554c0-.16.057-.248.136-.31.094-.073.257-.134.488-.134h2.018c.23 0 .394.06.488.134.08.062.136.15.136.31z",
    fill: "#EC368D",
    stroke: "#EC368D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 28h-4v8h4v-8z",
    fill: "#FFCF52"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28h-4v3.333h4V28z",
    fill: "#C3E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.337 18.893c0-2.208-2.296-4.002-5.129-4.002a6.573 6.573 0 00-.708.044c-1.2-2.303-3.804-3.903-6.833-3.903-4.165 0-7.542 3.019-7.542 6.743.001.246.017.492.047.736C5.31 19.11 4 20.54 4 22.209c0 2.208 2.296 4.002 5.13 4.002a6.09 6.09 0 003.075-.805c1.212.985 3.15 1.626 5.344 1.626 3.673 0 6.651-1.792 6.651-4.002 0-.146-.014-.292-.04-.435 1.864-.601 3.177-2.031 3.177-3.702z",
    fill: "#FFD6C0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.667 18l2.823-2.667 9.177 8.065V36H25.333v-8.301",
    stroke: "#2D2F33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.667 28h-4v8h4v-8zM40 28h-4v3.333h4V28zM29 15.333h2v2",
    stroke: "#2D2F33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36v-4.782L11.667 28M15.36 31.151l1.897-1.974",
    stroke: "#2D2F33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.337 18.893c0-2.208-2.296-4.002-5.129-4.002a6.573 6.573 0 00-.708.044c-1.2-2.303-3.804-3.903-6.833-3.903-4.165 0-7.542 3.019-7.542 6.743.001.246.017.492.047.736C5.31 19.11 4 20.54 4 22.209c0 2.208 2.296 4.002 5.13 4.002a6.09 6.09 0 003.075-.805c1.212.985 3.15 1.626 5.344 1.626 3.673 0 6.651-1.792 6.651-4.002 0-.146-.014-.292-.04-.435 1.864-.601 3.177-2.031 3.177-3.702z",
    stroke: "#2D2F33",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.333 24h-14",
    stroke: "#2D2F33",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgHouse;